import { Button, Flex } from 'antd';
import { BorderOutlined } from '@ant-design/icons';

export interface TaskbarItem {
  key: string;
  label: string;
}

/** Выше любого плавающего окна (их z-index растёт по счётчику от 1000 при каждом фокусе). */
const TASKBAR_Z_INDEX = 100000;

/**
 * Панель свёрнутых окон справа внизу (как панель задач в Windows): клик по плашке разворачивает
 * окно обратно — на то же место и в том же размере (окно не размонтировалось).
 */
export function WindowTaskbar({ items, onRestore }: { items: TaskbarItem[]; onRestore: (key: string) => void }) {
  if (items.length === 0) return null;
  return (
    <Flex
      data-testid="window-taskbar"
      gap={4}
      wrap
      justify="flex-end"
      style={{ position: 'fixed', right: 8, bottom: 8, maxWidth: 'calc(100vw - 16px)', zIndex: TASKBAR_Z_INDEX }}
    >
      {items.map(({ key, label }) => (
        <Button
          key={key}
          size="small"
          icon={<BorderOutlined />}
          title={`Развернуть: ${label}`}
          onClick={() => onRestore(key)}
          style={{ maxWidth: 240, fontSize: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.25)' }}
        >
          <span style={{ display: 'inline-block', maxWidth: 190, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', verticalAlign: 'bottom' }}>
            {label}
          </span>
        </Button>
      ))}
    </Flex>
  );
}
